import { useState } from "react";

interface Props {
  level: "high" | "medium" | "low";
}

const TOOLTIP_TEXT: Record<string, string> = {
  high: "AI can make mistakes. Always double check responses.",
  medium: "AI can make mistakes. Always double check responses.",
  low: "AI can make mistakes. Always double check responses.",
};

export default function ChatConfidence({ level }: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative flex items-center gap-[var(--chat-space-03)]">
      <span className="text-[var(--chat-text-xs)] font-medium leading-[1.5] text-[var(--chat-grey-500)]">
        Answer Confidence:
      </span>
      <div className="flex items-center gap-[var(--chat-space-01)]">
        <span className="text-[var(--chat-text-xs)] leading-[1.5] text-[var(--chat-grey-500)] capitalize">
          {level}
        </span>
        <button
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowTooltip((prev) => !prev)}
          className="relative"
          aria-label="What does this mean?"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--chat-grey-500)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </button>
      </div>

      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-2 w-[240px] bg-[var(--chat-black)] text-[var(--chat-white)] text-[var(--chat-text-xs)] leading-[1.5] rounded-[var(--chat-corner-base)] px-[var(--chat-space-04)] py-[var(--chat-space-03)] shadow-lg z-10">
          {TOOLTIP_TEXT[level]}
        </div>
      )}
    </div>
  );
}
